import React from 'react';
import { cn } from '../cn';
import { accentStyle } from './accents';
/** Controlled tab bar — flat underline style. */
export const Tabs = ({ items, value, onChange, accent = 'orange', className }) => {
    const a = accentStyle(accent);
    const handleKeyDown = (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')
            return;
        e.preventDefault();
        const enabled = items.filter((t) => !t.disabled);
        const idx = enabled.findIndex((t) => t.value === value);
        if (idx < 0)
            return;
        const next = e.key === 'ArrowRight'
            ? enabled[(idx + 1) % enabled.length]
            : enabled[(idx - 1 + enabled.length) % enabled.length];
        onChange(next.value);
    };
    return (React.createElement("div", { role: "tablist", "aria-orientation": "horizontal", onKeyDown: handleKeyDown, className: cn('flex items-end gap-1 border-b border-gray-200', className) }, items.map((tab) => {
        const active = tab.value === value;
        return (React.createElement("button", { key: tab.value, type: "button", role: "tab", "aria-selected": active, disabled: tab.disabled, tabIndex: active ? 0 : -1, onClick: () => onChange(tab.value), className: cn('relative -mb-px border-b-2 px-4 py-2.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2', a.tabFocus, active ? a.tabActive : a.tabInactive, tab.disabled && 'cursor-not-allowed opacity-40 hover:border-transparent') }, tab.label));
    })));
};
export default Tabs;
